// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root:root:root.select-templates-page .faux-modal__body{max-width:1000px;padding-left:min(60px,6vw);padding-right:min(60px,6vw);position:relative;z-index:0}:root:root:root.select-templates-page .faux-modal__wrapper{max-width:none;position:relative;z-index:0}:root:root:root.select-templates-page .button{display:inline-block!important;width:300px}", ""]);
// Exports
module.exports = exports;
